import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { EnvironmentService } from '../../@core/services/environment.service';
import { HrDocumentationService } from '../../services/hr-documentation.service';

@Component({
  selector: 'app-hr-documentation-mobile',
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
  ],
  templateUrl: './hr-documentation-mobile.component.html',
  styleUrls: ['./hr-documentation-mobile.component.scss']
})
export class HrDocumentationMobileComponent implements OnInit {

  constructor(
    private hrDocumentationService: HrDocumentationService,
    private router: Router,
    private envService: EnvironmentService
  ) { }

  ngOnInit(): void {
    this.hrDocumentationService.getHrDocumentationToken().subscribe(token => {
      // Redirect to the HR documentation portal with the token as a query parameter
      const urlWithToken = `${this.envService.hrDocumentationUrl}${token.encryptedToken}`;
      window.open(urlWithToken, '_self');
      this.router.navigateByUrl('/');
    });
  }
}
